import Carousel from './Carousel.vue'

export default Carousel
